import './App.css';
import Profileroutes from './routes/profileroutes';

function App() {
  return (
    <div className="App">
     <Profileroutes/>
    </div>
  );
}

export default App;
